import React from "react";
import { useNavigate } from "react-router-dom";
import background from "./images/background.png";
import HowToPlayModal from "./HowToPlayModal";

const SelectLevelPage = () => {
  const navigate = useNavigate();
  const easyLevel =
    "https://res.cloudinary.com/dbvqeiqxb/image/upload/w_192,h_192,c_fill,f_auto,q_auto/v1748136753/duck-easy-level-2_bihjls.png";
  const mediumLevel =
    "https://res.cloudinary.com/dbvqeiqxb/image/upload/w_192,h_192,c_fill,f_auto,q_auto/v1748136782/duck-medium-level-2_cwkpjp.png";
  const hardLevel =
    "https://res.cloudinary.com/dbvqeiqxb/image/upload/w_192,h_192,c_fill,f_auto,q_auto/v1748136804/duck-hard-level-2_fnmzj5.png";

  const levels = [
    {
      key: "easy",
      img: easyLevel,
      label: "Cute",
      description: "Empezamos tranqui, bebé. Pero igual fabulosa.",
      accent: "#7dd3fc", // sky blue
    },
    {
      key: "medium",
      img: mediumLevel,
      label: "Coquetona",
      description: "Ya con flow, pero sin perder el glam.",
      accent: "#c4b5fd", // lavender
    },
    {
      key: "hard",
      img: hardLevel,
      label: "Perrísima",
      description: "Full Karime mode. Solo pa' reinas.",
      accent: "#f9a8d4", // pink
    },
  ];

  return (
    <div
      className="flex flex-col min-h-full font-quicksand"
      style={{
        backgroundImage: `url(${background})`,
        backgroundRepeat: "repeat-y",
        backgroundSize: "100% auto",
        backgroundPosition: "top center",
      }}
    >
      <div className="px-5 pt-6 pb-8 flex flex-col">
        {/* Header */}
        <div className="mb-2">
          <h1
            className="text-xl font-extrabold text-center"
            style={{ color: "#2d1f3d" }}
          >
            ¿Básico como tu ex o perrísima como tú?
          </h1>
          <p className="text-center text-sm mt-1" style={{ color: "#9b7eaa" }}>
            Decide tu mood, bebé.
          </p>
        </div>

        <div className="flex justify-center mb-5">
          <HowToPlayModal />
        </div>

        {/* Level cards */}
        <div className="flex flex-col gap-4">
          {levels.map((level) => (
            <button
              key={level.key}
              onClick={() => navigate(`/game?difficulty=${level.key}`)}
              className="w-full active:scale-[0.97] transition-transform"
              style={{
                background: "rgba(255,255,255,0.9)",
                borderRadius: "24px",
                padding: "20px 24px",
                boxShadow: "0 4px 20px rgba(176,106,179,0.1)",
                border: `2px solid ${level.accent}`,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src={level.img}
                alt={level.label}
                loading="lazy"
                width={96}
                height={96}
                style={{ width: "96px", height: "96px", objectFit: "contain" }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = mediumLevel;
                }}
              />
              <span
                className="text-lg font-extrabold"
                style={{ color: "#2d1f3d" }}
              >
                {level.label}
              </span>
              <p className="text-sm text-center" style={{ color: "#9b7eaa" }}>
                {level.description}
              </p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SelectLevelPage;
